/**
 * AI 功能配置开关
 *
 * 用于控制 AI 功能的启用/禁用状态
 * 设置 NEXT_PUBLIC_AI_ENABLED=false 可禁用所有 AI 功能
 */

/** AI 功能是否启用 */
export const AI_ENABLED = process.env.NEXT_PUBLIC_AI_ENABLED === "true";

/** AI 功能禁用时的错误消息 */
export const AI_DISABLED_MESSAGE = "AI features are temporarily unavailable.";